<template>

  <title-container title="Guarantor and Borrower Application">
    <p class="mb-4">
      To start filling out the application, please select your borrower entity,
      if you do not see it you are able to create a new one. After selection,
      please select Start Application and eSign.
    </p>
    <b-container class="bv-example-row">
      <b-row>
        <b-col md="8" sm="12">

          <guarantor-entity-form @submit="submit" ref="applicationForm"/>
          <pdf-signature
            ref="appSignature" title="Borrower Application" @pdf-signed="false"/>
        </b-col>
        <b-col md="4" sm="12">
          <borrower-docs
            :documents="documents"
          />
        </b-col>
      </b-row>
    </b-container>
  </title-container>
</template>
<script>
import helper from '@/libs/helper';
import { DEFINE_PROFILE_APPLICATION } from '@/vuex/modules/profile/types/actions';

import ExplicitHint from '@/components/utils/hints/ExplicitHint';
import PdfSignature from '@/components/utils/PdfSignature';
import TitleContainer from '@/components/utils/TitleContainer';
import GuarantorEntityForm from '@/components/borrower_application/resources/GuarantorEntityForm';
import BorrowerDocs from '@/components/documents/BorrowerDocs';

const EXCLUDED_FOLDERS = [
  'Plaid',
  'Privacy Choices',
  'Privacy Notice',
  'Credit Authorization',
  'Financial Statement',
  'Bank Statement',
  'Tax Returns',
  'Borrower Stated Experience',
];

export default {
  name: 'Guarantor',
  components: {
    GuarantorEntityForm,
    ExplicitHint,
    PdfSignature,
    TitleContainer,
    BorrowerDocs,
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    documents() {
      return this.$store.getters.documents
        .filter(category => (!EXCLUDED_FOLDERS.includes(category.type)));
    },
  },
  methods: {
    submit() {
      if (!this.$refs.applicationForm.validate()) {
        return;
      }

      const model = this.$refs.applicationForm.model;
      this.$store.dispatch(DEFINE_PROFILE_APPLICATION, { application: helper.copy(model) });

      this.$reqs.post(`/users/${this.user.id}/profile/application/send`, model)
        .then((response) => {
          this.$refs.appSignature.show(response.data.docusign_url_embedded_signature);
        })
        .catch(() => {
          this.$notify({ group: 'alert', text: 'Failed to communicate with eSignature service.' });
        });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/borrower_application/Guarantor.vue